export const heroContent = {
  headline: "Hipobuy Spreadsheet: Find Better Products Faster With Smart Shopping Research",
  subheadline: "Explore thousands of organized product resources, shopping guides, comparison insights and quality checking strategies designed to help shoppers make smarter decisions.",
  primaryCTA: "Explore Hipobuy Spreadsheet",
  secondaryCTA: "Visit Main Platform",
  trustItems: [
    "Updated Spreadsheet Resources",
    "Product Research Guides",
    "Detailed Comparison Tables",
    "Beginner Friendly Tutorials",
  ],
};

export const whatIsContent = {
  title: "What Is Hipobuy Spreadsheet?",
  description: "Hipobuy Spreadsheet is a comprehensive product research database and shopping intelligence platform that helps online shoppers discover, compare, and evaluate products more efficiently. Instead of spending hours manually searching through countless product listings, Hipobuy Spreadsheet organizes product information into structured, searchable spreadsheets — making it easier to find exactly what you need.",
  comparisonRows: [
    { feature: "Research Time", normal: "Hours of manual browsing", hipobuy: "Minutes with organized data" },
    { feature: "Product Organization", normal: "Scattered across multiple tabs", hipobuy: "Centralized in one spreadsheet" },
    { feature: "Price Comparison", normal: "Manual note-taking required", hipobuy: "Built-in comparison views" },
    { feature: "Decision Making", normal: "Based on limited information", hipobuy: "Data-driven with full context" },
    { feature: "Beginner Experience", normal: "Overwhelming and confusing", hipobuy: "Guided and intuitive" },
  ],
};

export const whyChooseContent = {
  title: "Why Choose Our Hipobuy Spreadsheet?",
  cards: [
    {
      icon: "ri-search-eye-line",
      title: "Product Discovery",
      description: "Find organized product information quickly with our curated spreadsheet database. Browse through categories, filter by preferences, and discover items you never knew existed.",
    },
    {
      icon: "ri-bar-chart-box-line",
      title: "Shopping Intelligence",
      description: "Compare options side by side before making a purchase. Our spreadsheet format lets you evaluate prices, features, and quality metrics at a glance.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Quality Research",
      description: "Understand quality control standards and product evaluation criteria. Learn how to assess materials, craftsmanship, and authenticity before you buy.",
    },
    {
      icon: "ri-book-open-line",
      title: "Beginner Guides",
      description: "Learn step by step with our comprehensive tutorials. From understanding spreadsheet basics to advanced product research techniques, we have you covered.",
    },
  ],
};

export const safetyContent = {
  title: "Hipobuy Spreadsheet Safety Guide",
  intro: "Shopping online requires vigilance. Our safety guide helps you navigate product research with confidence, ensuring you make informed decisions while protecting your personal information.",
  tips: [
    {
      icon: "ri-links-line",
      title: "How To Avoid Risky Links",
      description: "Always verify product sources before clicking external links. Our spreadsheet includes verified product references so you can shop with peace of mind.",
    },
    {
      icon: "ri-lock-line",
      title: "How To Protect Personal Information",
      description: "Never share sensitive personal details when researching products. Use the information in our spreadsheet to evaluate sellers without exposing your data.",
    },
    {
      icon: "ri-file-search-line",
      title: "How To Verify Product Sources",
      description: "Cross-reference product listings with our spreadsheet database. Check seller ratings, product reviews, and return policies before committing to a purchase.",
    },
    {
      icon: "ri-secure-payment-line",
      title: "How To Shop Safely",
      description: "Use secure payment methods and keep transaction records. Our guides explain how to identify trustworthy sellers and avoid common online shopping pitfalls.",
    },
  ],
  safetyTable: [
    { risk: "Unverified Product Links", protection: "Use our spreadsheet-verified product references only" },
    { risk: "Suspicious Seller Activity", protection: "Check seller history and ratings in our database" },
    { risk: "Payment Security Issues", protection: "Always use secure, traceable payment methods" },
    { risk: "Privacy Data Exposure", protection: "Limit personal info shared during product research" },
  ],
};